import store from '@/store';

export default {
   path: '/multicotizador/agro/siniestros',
   name: 'siniestros',
   children: [
      {
         path: 'buscar',
         name: 'siniestros/buscar',
         component: () =>
            import(
               /* webpackChunkName: "BuscarSiniestroView" */ '@/modules/siniestros/views/BuscarSiniestroView.vue'
            ),
      },
      {
         path: 'denuncia',
         name: 'siniestros/denuncia',
         component: () =>
            import(
               /* webpackChunkName: "DenunciaSiniestroView" */ '@/modules/siniestros/views/DenunciaSiniestroView.vue'
            ),
         beforeEnter: (to, from, next) => {
            if (!store.state.siniestros.polizaDenunciar) {
               store.commit('main/resetClientData');
               next('/menu');
               return;
            }
            next();
         },
      },
   ],
};
